import './AppStatusMessage.scss';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { ExportOutlined } from '@ant-design/icons';
import React from 'react';
const FROM = '*From';
export const AppStatusMessage = ({ link, message }) => {
    if (!message) {
        return null;
    }
    return (React.createElement("div", { className: 'app-status-message' },
        React.createElement("div", { className: 'status-message-title' },
            React.createElement("div", { className: 'h3' }, COPY_SPECIFIC.APPLICATION_STATUS),
            React.createElement("a", { href: link, target: '_blank' },
                React.createElement(ExportOutlined, null))),
        message,
        React.createElement("div", { className: 'status-message-attribution' },
            FROM,
            React.createElement("a", { href: link, target: '_blank' }, link))));
};
